<script>
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";
import useValidation from "@/use/Validation";
import {ref} from "vue";
import useTools from "@/use/Tools";

export default {
    setup() {
        const {mxRules} = useValidation();
        const {$i18n, $refs} = useTools();
        const {dialog, loading} = useSharedData();
        const {getBack} = useSharedMethod();
        
        const impositions = [
            {id: "0", name: $i18n.t('pay_section.imposable_0')},
            {id: "1", name: $i18n.t('pay_section.imposable_1')},
            {id: "2", name: $i18n.t('pay_section.imposable_2')},
        ];
        
        const paySection = ref({
            imposable: "1",
            cotisable: "1",
            brute: "1",
            fixeInitial: "1"
            
        });
        
        function save() {
            if ($refs.form.validate()) {
                // TODO
            }
        }
        
        return {
            mxRules,
            dialog,
            loading,
            paySection,
            impositions,
            save,
            getBack
        }
    }
}
</script>

<template>
    <v-dialog
        v-model="dialog"
        persistent
        scrollable
        max-width="700"
    >
        <v-card>
            <w-toolbar color="teal" :title="`Création d'une rubrique de type: ${$t(`pay_section.easy_create.${$route.params.type}`)}`"/>
            <v-card-text>
                <v-container fluid>
                    <v-form ref="form" lazy-validation>
                        <v-row dense>
                            <v-col cols="12">
                                <strong>{{ $t('common.label') }} *</strong>
                                <w-text-field
                                    v-model="paySection.label"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-label :label="'تعيين'"/>
                                <w-text-field
                                    v-model="paySection.labelInArabic"
                                />
                            </v-col>
                        </v-row>
                        <br/>
                        <w-fieldset title="Options" v-if="$route.params.type !== 'ABSENCE_IN_DAYS' && $route.params.type !== 'ABSENCE_IN_HOURS'">
                            <v-row dense>
                                <v-col cols="12">
                                    <v-radio-group
                                        v-model="paySection.imposable"
                                        row
                                        class="mt-n2"
                                        hide-details="auto"
                                        :rules="[mxRules.required]"
                                    >
                                        <v-radio
                                            v-for="(imposition, index) in impositions"
                                            :key="index"
                                            :value="imposition.id"
                                            :label="imposition.name"
                                            color="red"
                                        />
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="6">
                                    <v-checkbox
                                        v-model="paySection.cotisable"
                                        :label="`${$t('pay_section.in_cotisable')}`"
                                        true-value="1"
                                        false-value="0"
                                        hide-details
                                        color="orange"
                                    />
                                </v-col>
                                <v-col cols="6">
                                    <v-checkbox
                                        v-model="paySection.brute"
                                        :label="`${$t('pay_section.in_brute')}`"
                                        true-value="1"
                                        false-value="0"
                                        hide-details
                                        color="cyan"
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <v-radio-group row v-model="paySection.fixeInitial">
                                        <v-radio :label="`${$t('pay_section.fixe')}`" value="1"/>
                                        <v-radio :label="`${$t('pay_section.variable')}`" value="3"/>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                        </w-fieldset>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn-add
                    show
                    :loading="loading"
                    @press="save"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped>

</style>